import { darkTheme, lightTheme } from '@apps/ui';

/**
 * Toggles `lightTheme` / `darkTheme` classes on <html> based on the user's
 * OS color-scheme preference. Returns a cleanup function suitable for use
 * with `useEffect`.
 */
export function applyColorScheme(): () => void {
  if (typeof window === 'undefined') return () => {};

  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const root = document.documentElement;

  const apply = (isDark: boolean) => {
    root.classList.toggle(darkTheme, isDark);
    root.classList.toggle(lightTheme, !isDark);
  };

  apply(mq.matches);

  const handle = (event: MediaQueryListEvent) => apply(event.matches);
  mq.addEventListener('change', handle);
  return () => mq.removeEventListener('change', handle);
}
